/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdevang_Theologie16Inputs */

const en__field_enum_sdevang_theologie16 = /** @type {(inputs: _Field_Enum_Sdevang_Theologie16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`06 - Evangelische Theorie`)
};

const de__field_enum_sdevang_theologie16 = /** @type {(inputs: _Field_Enum_Sdevang_Theologie16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`06 - Evangelische Theorie`)
};

/**
* | output |
* | --- |
* | "06 - Evangelische Theorie" |
*
* @param {_Field_Enum_Sdevang_Theologie16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdevang_theologie16 = /** @type {((inputs?: _Field_Enum_Sdevang_Theologie16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdevang_Theologie16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdevang_theologie16(inputs)
	return de__field_enum_sdevang_theologie16(inputs)
});
export { _field_enum_sdevang_theologie16 as "_field_enum_SDEVANG_THEOLOGIE" }